/* eslint-disable */

export default {
  "signup.title": "Cadastre-se",
  "signup.subtitle": "ou entre na sua conta",
  "signup.tos": "Eu concordo com os termos de serviço do RELE.AI",
  "signup.privacy": "Eu concordo com os termos de privacidade do RELE.AI",
  "signup.chooseMethod": "Crie sua conta",
  "signup.provideNumberDescription": "Olá 👋 <br />Indique seu número de celular para ter acesso a RELE.AI, sua assistente de CRM.",
  "signup.createOrganizationDescription": "Por favor, dê um nome a sua empresa.<br/>Uma vez criada, você poderá conectar seu CRM e convidar membros da equipe.",
  "signup.firstIntegrationDescription": "Conecte RELE.AI com uma das integrações abaixo. Você sempre pode alterá-lo ou adicionar mais integrações posteriormente na página de integrações.",
  "globals.search": "Buscando...",
  "globals.hi": "Olá,",
  "globals.contactClara": "Contatar RELE.AI",
  "globals.page": "Página",
  "globals.authDivider": "ou",
  "globals.month": "Mês",
  "globals.year": "Ano",
  "payments.activeSubscription.dialogs.update.title": "Alterar plano de assinatura",
  "payments.activeSubscription.dialogs.update.description": "RELE.AI oferece planos mensais e anuais que podem ser vistos em nossa <a href=\"https://rele.ai/pricing/\" target=\"_blank\" about class=\"text-r-primary\">página de preços.</a><br /> Se desejar alternar entre os planos, basta selecionar o plano desejado no menu suspenso e clicar em Salvar.",
  "payments.activeSubscription.dialogs.update.plans": "Planos",
  "payments.activeSubscription.dialogs.delete.title": "Cancelar assinatura",
  "payments.activeSubscription.dialogs.delete.description": "<div class =\"font-semibold\"> Não queremos que você vá embora 😢 </div><br /> Tem certeza de que deseja cancelar sua assinatura?<br/>Vamos conversar primeiro <a href='mailto:support@rele.ai' class=\"text-r-primary\">support@rele.ai</a>",
  "payments.activeSubscription.invoices.title": "Faturas",
  "payments.activeSubscription.invoices.created": "Data da fatura",
  "payments.activeSubscription.invoices.amountPaid": "Valor pago",
  "payments.activeSubscription.invoices.invoicePdf": "Baixar fatura",
  "payments.activeSubscription.invoices.emptyItems": "Sem faturas por agora",
  "payments.activeSubscription.subscriptionInfo.title": "Detalhes da assinatura",
  "payments.activeSubscription.subscriptionInfo.startDate": "Data de início",
  "payments.activeSubscription.subscriptionInfo.plan": "Plano",
  "payments.activeSubscription.subscriptionInfo.price": "{amount} {currency} / usuário / {interval}",
  "payments.activeSubscription.subscriptionInfo.amountOfUsers": "Contagem de usuários",
  "payments.table.title": "Pagamentos",
  "payments.yearly": "Planos anuais",
  "payments.monthly": "Planos mensaias",
  "payments.small": "Pequeno",
  "payments.contactUs": "Entre em contato",
  "payments.enterprise": "Empresarial",
  "payments.smallDescription": "Pequena ou média empresa?<br />Este plano suporta até 100 usuários",
  "payments.enterpriseDescription": "Tem mais de 100 usuários?<br />Fale conosco",
  "payments.planLayout_monthly": "usuário/mês",
  "payments.planLayout_yearly": "usuário/ano",
  "payments.welcome": "Estamos muito felizes por tê-lo conosco! <br /><br />Se precisar de ajuda, basta entrar em contato conosco em <a href='mailto:support@rele.ai' class='text-r-primary'>support@rele.ai</a>",
  "payments.errorOnCheckout": "Algo deu errado 😕 <br /><br />Vamos ajudá-lo, basta enviar-nos um e-mail em <a href='mailto:support@rele.ai' class='text-r-primary'>support@rele.ai</a>",
  "payments.alertDialog.title": "Sua conta de teste acabou",
  "payments.alertDialog.description": "Organize o pagamento por meio desta página e continue documentando por meio de RELE.AI.",
  "payments.alertDialog.checkbox": "Não mostrar essa mensagem novamente",
  "usersManagement.user": "Usuário",
  "usersManagement.table.name": "Nome do funcionário",
  "usersManagement.table.email": "Endereço de e-mail",
  "usersManagement.table.phone": "Número de celular",
  "usersManagement.table.actions": "Ações",
  "usersManagement.table.title": "Gerenciamento do usuário",
  "usersManagement.table.addNew": "Adicionar usuário",
  "usersManagement.table.noUserFound": "Ops. Nenhum usuário encontrado que corresponda aos seus requisitos.",
  "usersManagement.deleteDialog.title": "Deletar usuário",
  "usersManagement.deleteDialog.description": "Tem certeza de que deseja excluir {name}?",
  "activeIntegrations.integration": "Integração",
  "activeIntegrations.table.title": "Integrações ativas",
  "activeIntegrations.table.noIntegrations": "Ops!<br /> Você não tem nenhuma integração ativa.<br /> Ative uma das integrações e comece a documentar.",
  "nonActiveIntegrations.title": "Mercado eletrónico",
  "nonActiveIntegrations.description": "Para habilitar uma das integrações abaixo, clique no cartão de integração e siga as instruções.",
  "nonActiveIntegrations.hubspot.title": "Integração com Hubspot",
  "nonActiveIntegrations.hubspot.description": "Integre sua conta do CRM Hubspot .",
  "nonActiveIntegrations.salesforce.title": "Integração com Salesforce",
  "nonActiveIntegrations.salesforce.description": "Integre sua conta do CRM Salesforce.",
  "nonActiveIntegrations.mailing.title": "Integração com e-mail",
  "nonActiveIntegrations.mailing.description": "Integre sua conta de e-mail.",
  "nonActiveIntegrations.noIntegrations": "Parabéns! <br /> Você ativou todas as integrações.",
  "integrations.apps.unknownAppError": "Aplicativo desconhecido, tenha cuidado",
  "integrations.apps.unexpectedRedirect": "Redirecionamento inesperado, certifique-se de que autorizou o aplicativo correto",
  "integrations.apps.unknown.displayName": "Aplicativo desconhecido",
  "integrations.apps.unknown.description": "Não conceda acesso a este aplicativo se não tiver certeza do que está fazendo!",
  "integrations.table.title": "Integrações",
  "integrations.crm.giveCarlaAccess": "Para conectar RELE.AI, siga estas etapas",
  "integrations.crm.title": "Integrações de CRM",
  "integrations.crm.noCrmConnections": "Você ainda não forneceu a RELE.AI acesso ao seu CRM.",
  "integrations.crm.connectCrm": "Conectar CRM",
  "integrations.crm.apiKey": "Chave API",
  "integrations.crm.updateConnection": "Editar",
  "integrations.crm.selectCRM": "Selecione um CRM",
  "integrations.crm.salesforce.guide": "<ol class=\"list-decimal\"><li>Faça login no Salesforce clicando no botão abaixo</li><li>Aprovar o acesso a RELE.AI</li></ol>",
  "integrations.crm.salesforce.releaiPackage": "<div>• Antes de entrar no Salesforce, você deve vincular sua conta do Salesforce ao aplicativo RELE.AI Salesforce. <br /><div style='margin-top: 10px;'>• Verifique com o administrador do Salesforce se o aplicativo já está instalado. Se não estiver instalado, você pode fazer isso clicando <a style='color: blue;' href=\"https://login.salesforce.com/packaging/installPackage.apexp?p0=04t3z000001zs7p\" target=\"_blank\">aqui</a>.</div><div style='margin-top: 10px;'>• Para mais informações: <a style='color: blue;' href=\"https://rele.ai/how-to-connect-salesforce/\" target=\"_blank\">https://rele.ai/how-to-connect-salesforce</a></div></div>",
  "integrations.crm.hubspot.chooseAuth.oauth": "Faça login com HubSpot",
  "integrations.crm.hubspot.chooseAuth.apiKey": "Chave API",
  "integrations.crm.hubspot.chooseAuth.title": "Escolha o método de autenticação",
  "integrations.crm.hubspot.chooseAuth.description": "Selecione sua conexão com o Hubspot. Você pode escolher se conectar usando a chave API de sua conta do hubspot ou usando o login OAuth.",
  "integrations.crm.hubspot.chooseAuth.chooseAuthMethodTitle": "Qual o método de autenticação do Hubspot que devo escolher?",
  "integrations.crm.hubspot.chooseAuth.chooseAuthMethodDesc": "<div>A ligação ao hubpost utilizando a <span style='font-weight: 800'>Chave API</span> dará permissão a <span style='font-weight: 800'>todos os utilizadores</span> que adicionar sob a Consola RELE.AI para utilizar o hubpsot via RELE.AI.<div style='margin-top: 5px;'>A ligação ao hubpost usando <span style='font-weight: 800'>Faça login com HubSpot</span> dará permissão <span style='font-weight: 800'>apenas ao seu utilizador para usar</span> o hubpsot via RELE.AI.</div></div>",
  "integrations.crm.hubspot.guideOauth": "<ol class=\"list-decimal\"><li> Faça login no Hubspot clicando no botão abaixo</li><li>Aprovar acesso a RELE.AI</li></ol>",
  "integrations.crm.hubspot.guideApiKey": "<ol class=\"list-decimal\"><li> Faça login em sua conta HubSpot</li><li>Acesse as configurações do HubSpot clicando em seu perfil-> Perfil e preferências</li><li>No menu à esquerda vá para Integrações -> Chave API</li><li> Copie a chave de API e cole-a na entrada abaixo</li></ol>",
  "integrations.crm.hubspot.docs.part1": "Não encontrou? Por favor visite",
  "integrations.crm.hubspot.docs.link": "este",
  "integrations.crm.hubspot.docs.part2": "link para explicação mais detalhada",
  "integrations.crm.deleteDialog.title": "Excluir integração",
  "integrations.crm.deleteDialog.description": "Tem certeza de que deseja excluir a integração {name}?",
  "integrations.mailing.guide": "Permita o acesso para envio de e-mails clicando na caixa de seleção.",
  "integrations.mailing.checkbox.enable": "O e-mail está habilitado.",
  "integrations.mailing.checkbox.disable": "O e-mail está desativado",
  "integrations.mailing.checkbox.disableInfo": "Adicione um endereço de e-mail para habilitar o recurso de e-mail.",
  "notifications.trailEndIn": "Seu teste termina em {days}. Por favor, complete suas informações de pagamento. 🤑",
  "notifications.editSuccess": "Parabéns! Você acabou de atualizar {name}.",
  "notifications.createSuccess": "Parabéns! Você acabou de criar {name}.",
  "forms.firstname": "Nome",
  "forms.lastname": "Sobrenome",
  "forms.email": "Endereço de e-mail",
  "forms.mobile": "Número de celular",
  "forms.workspace": "Nome da empresa",
  "forms.botLang": "Idioma de bot preferido",
  "forms.claraNumber": "Número preferido",
  "forms.password": "Senha",
  "placeholders.enterYourEmail": "Insira o seu endereço de e-mail",
  "placeholders.enterYourPassword": "Insira a sua senha",
  "buttons.continueWithGoogle": "Continuar com Google",
  "buttons.continueWithMicrosoft": "Continuar com Microsoft",
  "buttons.signInWithEmailAndPassword": "Entrar com e-mail e senha",
  "buttons.next": "Próximo",
  "buttons.back" :"Voltar",
  "buttons.getStarted": "Próximo",
  "buttons.edit": "Editar",
  "buttons.save": "Salvar",
  "buttons.delete": "Excluir",
  "buttons.cancel": "Cancelar",
  "buttons.signOut": "Sair",
  "buttons.continueWithEmail": "Continuar com E-mail",
  "buttons.continueWithSalesforce": "Continuar com Salesforce",
  "buttons.continueWithHusbpot": "Continuar com Hubspot",
  "buttons.botSettings": "Configurações do Bot",
  "buttons.changePlan": "Alterar plano",
  "buttons.cancelSubscription": "Cancelar assinaturar",
  "buttons.consoleSettings": "Configurações do console",
  "buttons.close": "Fechar",
  "buttons.ok": "OK",
  "buttons.authorize": "Autorizar",
  "buttons.deleteCompany": "eliminar empresa",
  "errors.unableToAuthenticateTitle": "Não foi possível completar a autenticação",
  "errors.missingRequiredField": "Campos obrigatórios em falta",
  "errors.unableToCreateUser": "Não foi possível criar o usuário",
  "errors.unableToDeleteUser": "Não foi possível deletar o usuário",
  "errors.unableToLoginWithSalesforce": "Não foi possível fazer o login com o Salesforce.",
  "errors.unableToLoginWithHubspot": "Não foi possível fazer o login com o Husbpot.",
  "errors.unableToEnableMailing": "Não foi possível integrar o pagamento.",
  "errors.unableToCreatePaymentSubscription": "Não foi possível efetuar o pagamento.",
  "errors.unableToChangeSubscription": "Não foi possível alterar o plano de assinatura.",
  "errors.unableToCancelSubscription": "Não foi possível cancelar a assinatura. Entre em contato com nossa equipe de suporte.",
  "errors.unableToDeleteIntegration": "Não foi possível excluir a integração.",
  "errors.unableToSaveBotSettings": "Não foi possível salvar as configurações do bot.",
  "errors.workspaceNameRequired": "O nome do espaço de trabalho é obrigatório",
  "errors.unableToCreateNewOrg": "Não foi possível criar a empresa",
  "errors.unableToUpdateUserWithOrgId": "Não foi possível anexar o usuário à empresa",
  "errors.validateEmail": "Endereço de e-mail inválido. Por favor insira um endereço de e-mail válido.",
  "errors.validateFirstName": "Nome inválido. Não insira espaços ou caracteres especiais.",
  "errors.validateLastName": "Sobrenome inválido. Não insira caracteres especiais ao lado de `-`",
  "errors.validateMobile": "Existe um usuário existente com o mesmo número.",
  "errors.validateHubspotAPIKey": "A chave API é inválida. Clique no link acima para obter uma explicação de como encontrá-la.",
  "botOptions.inherit": "Idioma da empresa padrão",
  "botOptions.en": "Inglês",
  "botOptions.es": "Espanhol",
  "botOptions.fr": "Francês",
  "botOptions.gr": "Alemão",
  "botOptions.pt": "Português",
  "botSettings.title": "Configurações do bot",
  "consoleSettings.title": "Configurações do console",
  "consoleSettings.locale": "Idioma do console",
  "deleteCompany.title": "eliminar empresa"
}
